
export default {
  props: {
    filterProp: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      keyword: ''
    };
  },
  watch: {
    filterProp: {
      handler() {
        if (this.filterProp !== null) {
            this.keyword = this.filterProp
        } else {
          this.keyword = ''
        }
        this.$emit('value-changed', this.keyword)
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    handleChange () {
      this.$emit('value-changed', this.keyword)
    },
  }
}
